<template>
  <div>
    <drawer :app="app" />

    <v-container class="mt-1">
      <v-card raised>
        <v-card-title>
          {{$t('labels.Interview')}}
        </v-card-title>

        <div style="margin: 15px 5px 5px 15px;">
          <div class="body-1" v-text="$t('labels.WhatThePurposeOfYourMortgageApplication')"></div>
          <v-radio-group @mousedown="onPurposeClick"  v-model="app.InterView.DealPurposeDD" :mandatory="false">
            <v-radio color="primary" :label="$t('labels.PurchasingANewHome')" :value="0"></v-radio>
            <v-radio color="primary" :label="$t('labels.RenewingExistingMortgage')" :value="4"></v-radio>
            <v-radio color="primary" :label="$t('labels.RefinancingExistingMortgage')" :value="2"></v-radio>
            <v-radio color="primary" :label="$t('labels.ConstructionRefinancing')" :value="3"></v-radio>
          </v-radio-group>

          <div v-if="app.InterView.DealPurposeDD == 0">
            <div class="body-1" v-text="$t('labels.WhatStageAreYouAtSearchForProperty')"></div>
            <v-radio-group v-model="app.InterView.SearchStageDD" :mandatory="false">
              <v-radio color="primary" :label="$t('labels.OfferWasAccepted')" :value="1"></v-radio>
              <v-radio color="primary" :label="$t('labels.FoundAPropertyPlacedOffer')" :value="2"></v-radio>
              <v-radio color="primary" :label="$t('labels.FoundAPropertyNoOffer')" :value="3"></v-radio>
              <v-radio color="primary" :label="$t('labels.ActivelySearching')" :value="4"></v-radio>
              <v-radio color="primary" :label="$t('labels.DidNotStartSearchProperty')" :value="5"></v-radio>
            </v-radio-group>

            <div v-if="app.InterView.SearchStageDD >= 1">
              <div v-if="app.InterView.SearchStageDD < 4">
                <div class="body-1" v-text="$t('labels.WhatPurchasePrice')"></div>               

                <p_money style="max-width:400px;" v-model="app.InterView.PropertyValue" />
              </div>

              <div class="body-1" v-text="$t('labels.WhatAmountOfDownPayment')"></div>
              <p_money style="max-width:400px;" v-model="app.InterView.DownPaymentAmount" />
              
              <div class="body-1" v-text="$t('labels.EstimatedClosingDate')"></div>
              <div style="max-width:400px;">
              <comdatey :min="new Date().toISOString().substr(0, 10)" :max="date5Years" v-model="app.InterView.ClosingDate" />
              </div>

              <div v-if="app.InterView.SearchStageDD < 4">
                <div class="body-1" v-text="$t('labels.WhatTypeOfProperty')"></div>                
                
                <p_propertytype v-model="app.InterView.PropertyTypeDD" />                
                
                <div class="body-1" v-text="$t('labels.WhatIsOccupancyType')"></div>
                <com_dd_radio :menucode="'OccupancyType'" v-model="app.InterView.OccupancyDD" />
              </div>


            </div>
          </div>

          <div v-if="app.InterView.DealPurposeDD == 4">
            <div class="body-1" v-text="$t('labels.RenewDate')"></div>
            <comdatey :min="new Date().toISOString().substr(0, 10)" :max="date5Years" v-model="app.InterView.ClosingDate"  />

            <div class="body-1" v-text="$t('labels.MortgageAmountRequired')"></div>
            <p_money v-model="app.InterView.Balance" />
          </div>

          <div v-if="app.InterView.DealPurposeDD == 2">
            <div class="body-1" v-text="$t('labels.TargetRefinanceDate')"></div>
            <comdatey :min="new Date().toISOString().substr(0, 10)" :max="date5Years" v-model="app.InterView.ClosingDate" />

              <div class="body-1" v-text="$t('labels.MortgageAmountRequired')"></div>
            <p_money v-model="app.InterView.Balance" />
          </div>



          <div v-if="app.InterView.DealPurposeDD == 3">
            <div class="body-1" v-text="$t('labels.LandOwnership')"></div>
              <v-radio-group v-model="app.LandOwnership" :mandatory="false">
              <v-radio color="primary" :label="$t('labels.CLI_Yes')" :value="1"></v-radio>
              <v-radio color="primary" :label="$t('labels.CLI_No')" :value="2"></v-radio>              
            </v-radio-group>
            
            <div class="body-1" v-text="$t('labels.TargetClosingDate')"></div>

            <comdatey
              v-if="app.LandOwnership>0"
             :min="new Date().toISOString().substr(0, 10)" :max="date5Years" v-model="app.InterView.ClosingDate" />

            <div class="body-1" v-text="$t('labels.EstimatedLoanAmount')" />
             <p_money v-model="app.InterView.Balance" /> 
          </div>


          <div v-if="(app.InterView.DealPurposeDD == 0 && app.InterView.SearchStageDD!=null && app.InterView.SearchStageDD < 4) || app.InterView.DealPurposeDD == 4 || app.InterView.DealPurposeDD == 2 || app.InterView.DealPurposeDD==3">
               <div class="body-1" v-text="$t('labels.PropertyAddress')"></div>              
              <p_addr v-model="app.RequestedMortgage.SubjectProperty.Address" :easyModeFlag="true" />
          </div>

          <v-card-actions class="mb-5 mt-10">
            <v-spacer />
            <v-btn @click="next" color="primary float-right">{{ $t("labels.Next") }}</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-container>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawer";
import { EventBus } from "@/services/eventBus";
import model from "@/shared/dataModels/app";
import comdatey from "@/shared/components/datePickerY";

import p_propertytype from "./propertyType";
import com_dd_radio from "@/shared/components/ddRadios";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import p_money from "@/shared/components/money";
import p_addr from "@/shared/components/addr";

export default {
  components: {
    p_addr,
    p_money,
    drawer,
    comdatey,
    p_propertytype,
    com_dd_radio
  },
  data() {
    return {
      frmReady: false,
      loadFlag: false,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      drawerFlag: false,
      date: null,
      app: model.appModel()
    };
  },
  methods: {   
    onDownPaymentChange() {
      if (this.app.InterView.DownPaymentAmount < 0) {
        this.$nextTick(() => {
          this.app.InterView.DownPaymentAmount = 0;
        });
      }
    },
    onPropertyValueChange() {
      if (this.app.InterView.PropertyValue < 0) {
        this.$nextTick(() => {
          this.app.InterView.PropertyValue = 0;
        });
      }
    },
    next() { 
      if (this.valid()) {
        this.loadFlag=true;
        dataSvc
          .getHttp()
          .post("/api/MTGAPPSaveInterView", this.app)
          .then(res => {
            this.loadFlag = false;
            if (res.data.ReturnStatus.ReturnCode == 200) {
              let mortgagesApplicationID = res.data.MortgageApplicationID;
              let mainApplicantID = res.data.MainApplicantID;

              let nextUrl = "/" + this.siteID + "/user/" + mortgagesApplicationID + "/applicant/" + mainApplicantID + "/identification";
              this.$router.push(nextUrl);
            }
          }).catch(err=>{
            console.error( err );
            this.$router.push('/' + this.siteID );
            this.loadFlag = false;
          });
      }
    },
    valid() {      
      if (this.app.InterView.DealPurposeDD == null) {
        this.$alert(this.$t("labels.Warning"), this.$t("errors.InterViewMissingPurpose"));
        return false;
      }

      if (this.app.InterView.DealPurposeDD == 0) {
        this.app.InterView.RefinanceDate = null;
        this.app.InterView.RenewingDate = null;

        if (this.app.InterView.SearchStageDD == null) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.InterViewMissingSearchStatus"));
          return false;
        }
        if (this.app.InterView.SearchStageDD < 4) {
          if (this.app.InterView.PropertyValue == null || this.app.InterView.PropertyValue <= 0) {
            this.$alert(this.$t("labels.Warning"), this.$t("errors.InterViewMissingPropertyValue"));
            return false;
          }

          if (this.app.InterView.PropertyTypeDD == null) {
            this.$alert(this.$t("labels.Warning"), this.$t("errors.InterViewMissingPropertyType"));
            return false;
          }

          if (this.app.InterView.OccupancyDD == null) {
            this.$alert(this.$t("labels.Warning"), this.$t("errors.InterViewMissingOccupancy"));
            return false;
          }         
           if (this.app.InterView.ClosingDate == null || this.app.InterView.ClosingDate == "") {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.InterViewMissingClosingDate"));
          return false;
        }
        } else {
          
          // not found property
          this.app.InterView.PropertyValue = null;
          this.app.InterView.PropertyTypeDD = null;
          this.app.InterView.OccupancyDD = null;
        }
        if (this.app.InterView.DownPaymentAmount == null || this.app.InterView.DownPaymentAmount <= 0) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.InterViewMissingDownPayment"));
          return false;
        }       
      }

      if (this.app.InterView.DealPurposeDD == 4) {
        if (this.app.InterView.ClosingDate == null) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.InterViewMissingRenewDate"));
          return false;
        }
        // clear data
        this.app.InterView.PropertyValue = null;
        this.app.InterView.PropertyTypeDD = null;
        this.app.InterView.OccupancyDD = null;
        this.app.InterView.DownPaymentAmount = null;
      }

      if (this.app.InterView.DealPurposeDD == 2) {
        if (this.app.InterView.ClosingDate == null) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.InterViewMissingRefinanceDate"));
          return false;
        }
        // clear data
        this.app.InterView.PropertyValue = null;
        this.app.InterView.PropertyTypeDD = null;
        this.app.InterView.OccupancyDD = null;
        this.app.InterView.DownPaymentAmount = null;
      }

      if(this.app.InterView.DealPurposeDD==3){
        if (this.app.InterView.ClosingDate == null) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.InterViewMissingClosingDate"));
          return false;
        }
      }

      let needAddress = false;
      if(  this.app.InterView.DealPurposeDD == 2 || this.app.InterView.DealPurposeDD == 4 ){
        needAddress = true;
      } else {
        if(this.app.InterView.DealPurposeDD == 0 && this.app.InterView.SearchStageDD < 4){
          needAddress = true;
        }
      }
 
      if(needAddress){
        if (!this.app.RequestedMortgage.SubjectProperty.Address.StreetName || this.app.RequestedMortgage.SubjectProperty.Address.StreetName == '') {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.MortgageMissingAddress"));
          return false;
        }        
      }

      return true;
    },
    setOccupancy(v) {
      setTimeout(() => {
        this.app.InterView.OccupancyDD = -1;
        setTimeout(() => {
          this.app.InterView.OccupancyDD = Number(v);
        }, 500);
      }, 500);
    },
    setPropertyType(v) {
      setTimeout(() => {
        this.app.InterView.PropertyTypeDD = -1;
        setTimeout(() => {
          this.app.InterView.PropertyTypeDD = Number(v);
        }, 500);
      }, 500);
    },
    loadPage() {
      if (this.appID != 0) {
        this.loadFlag = true;
        let postData = {
          SiteID: this.siteID,
          UserID: this.userID,
          MortgageApplicationID: this.mortgageApplicationID
        };
        dataSvc
          .getHttp()
          .post("/api/MTGAPPLoad", postData)
          .then(res => {
            this.loadFlag = false;
            if (res.data.ReturnStatus.ReturnCode == 200) {
              this.app = res.data;
 
              setTimeout(() => {
                this.app.InterView.ClosingDate = res.data.InterView.strClosingDate;
                //this.app.InterView.RefinanceDate = res.data.InterView.strRefinanceDate;
                //this.app.InterView.RenewingDate = res.data.InterView.strRenewingDate;
                this.setOccupancy(res.data.InterView.OccupancyDD);
                this.setPropertyType( res.data.InterView.PropertyTypeDD);
              }, 200);
            }

      if(!this.app.RequestedMortgage){
                this.app.RequestedMortgage= model.mortgageRequestModel();
              }
            this.app.UserID = this.userID;
            this.app.SiteID = this.siteID;
          });
      } else {
        this.app.UserID = this.userID;
        this.app.SiteID = this.siteID;
      }
    },
    show() {},
    onSwitchPropose(){
       this.app.InterView.ClosingDate=null;
       this.app.InterView.strClosingDate=null;
       this.app.InterView.strClosingDateMMM=null;
       this.app.InterView.SearchStageDD=null;
       this.app.InterView.PropertyValue=null;
       this.app.InterView.strPropertyValue=null;
       this.app.InterView.DownPaymentAmount=null;
       this.app.InterView.strDownPaymentAmount=null;
       this.app.InterView.PropertyTypeDD=null;
       this.app.InterView.OccupancyDD=null;
       this.app.InterView.strOccupancy=null;
       this.app.InterView.Balance=null; 
    },
    onPurposeClick(){
      this.frmReady = true;
    }
  },
  created() {
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
      this.loadPage();
    } else {
      this.$router.push("/" + this.siteID);
    }
  },
  computed: {
    date5Years() {
      let n = new Date();
      n.setFullYear(n.getFullYear() + 5);
      return n.toISOString().substr(0, 10);
    }
  },
  mounted() {    
    EventBus.$on("drawStatusChange", isOpen => {
      this.drawerFlag = isOpen;
    });
  },
  beforeDestroy() {
    EventBus.$off("drawStatusChange");
  },
  watch:{
    "app.InterView.DealPurposeDD":{
       handler(n,o) {
         if(this.frmReady){
           if(n!=o){
              this.onSwitchPropose();

              if(n==3){
                if(!this.app.LandOwnership)
                  this.app.LandOwnership=1;
              }
           }
         }
       },
      deep: false
    }
  }
};
</script>
<style scoped>
.body-1{
  font-weight: 500 !important;
}
</style>